module.exports = __webpack_public_path__ + "img/SWP_Shield_06.f2a6338f.png";